import { Button } from '@mui/material'

import type React from 'react'

interface CartToolbarButtonProps {
  label: string
  icon: React.ReactNode
  onClick: () => void
  disabled?: boolean
}

/**
 * Pill-shaped, quiet secondary action for the cart toolbar (New draft / New team order).
 * Surface + divider tokens keep it flat against the page content in light and dark themes;
 * pill radius, no-elevation and sentence case come from the theme's MuiButton defaults.
 */
export const CartToolbarButton: React.FC<CartToolbarButtonProps> = ({
  label,
  icon,
  onClick,
  disabled,
}) => (
  <Button
    size="small"
    startIcon={icon}
    onClick={onClick}
    disabled={disabled}
    sx={{
      bgcolor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      color: 'text.primary',
      fontWeight: 'fontWeightMedium',
      paddingX: 1.5,
      whiteSpace: 'nowrap',
      '&:hover': { bgcolor: 'action.hover', borderColor: 'divider' },
      '&:active': { bgcolor: 'action.selected' },
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: 'primary.main',
        outlineOffset: '2px',
      },
      '&.Mui-disabled': {
        bgcolor: 'background.paper',
        borderColor: 'divider',
        color: 'text.disabled',
      },
    }}>
    {label}
  </Button>
)
